import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class LoginService {
    private showPopup: any = false;

    constructor(private dialog: MatDialog, private route: ActivatedRoute) {
        this.checkQueryParams();
    }

    private checkQueryParams(): void {
        this.route.queryParams.subscribe(params => {
            if (params['showPopup'] !== undefined) {
                this.showPopup = params['showPopup'] === 'true';
            }
        });
    }

    get showPopupValue(): boolean {
        return this.showPopup;
    }


}
